import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from 'react';
import { INSERT_BLOCK_SECTION, TASK_LIST_GROUP, MEDIA_GROUP, INSERT_BLOCK_SECTION_RANK, TASK_LIST_BUTTON, TASK_LIST_GROUP_RANK, MEDIA_BUTTON, MENTION_GROUP, MEDIA_GROUP_RANK, MENTION_BUTTON, MENTION_GROUP_RANK, EMOJI_GROUP, EMOJI_BUTTON, EMOJI_GROUP_RANK, LAYOUT_GROUP, LAYOUT_BUTTON, LAYOUT_GROUP_RANK, TABLE_GROUP_RANK, TABLE_BUTTON, TABLE_GROUP, TABLE_SIZE_PICKER, INSERT_GROUP, INSERT_BUTTON, INSERT_GROUP_RANK } from '@atlaskit/editor-common/toolbar';
import { Show, ToolbarButtonGroup } from '@atlaskit/editor-toolbar';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
import { EmojiButton } from './toolbar-components/EmojiButton';
import { ImageButton } from './toolbar-components/ImageButton';
import { InsertButton } from './toolbar-components/InsertButton';
import { LayoutButton } from './toolbar-components/LayoutButton';
import { MediaButton } from './toolbar-components/MediaButton';
import { MentionButton } from './toolbar-components/MentionButton';
import { TableButton } from './toolbar-components/TableButton';
import { TableSizePicker } from './toolbar-components/TableSizePicker';
import { TaskListButton } from './toolbar-components/TaskListButton';
export var getToolbarComponents = function getToolbarComponents(_ref) {
  var api = _ref.api,
    tableSelectorSupported = _ref.tableSelectorSupported,
    toolbarShowPlusInsertOnly = _ref.toolbarShowPlusInsertOnly,
    showElementBrowserLink = _ref.showElementBrowserLink,
    onInsertBlockType = _ref.onInsertBlockType,
    nativeStatusSupported = _ref.nativeStatusSupported,
    horizontalRuleEnabled = _ref.horizontalRuleEnabled,
    expandEnabled = _ref.expandEnabled,
    insertMenuItems = _ref.insertMenuItems;
  return _toConsumableArray(toolbarShowPlusInsertOnly ? [{
    type: INSERT_GROUP.type,
    key: INSERT_GROUP.key,
    parents: [{
      type: INSERT_BLOCK_SECTION.type,
      key: INSERT_BLOCK_SECTION.key,
      rank: INSERT_BLOCK_SECTION_RANK[INSERT_GROUP.key]
    }]
  }, {
    type: INSERT_BUTTON.type,
    key: INSERT_BUTTON.key,
    parents: [{
      type: INSERT_GROUP.type,
      key: INSERT_GROUP.key,
      rank: INSERT_GROUP_RANK[INSERT_BUTTON.key]
    }],
    component: function component() {
      return /*#__PURE__*/React.createElement(InsertButton, {
        api: api,
        showElementBrowserLink: showElementBrowserLink,
        tableSelectorSupported: tableSelectorSupported,
        onInsertBlockType: onInsertBlockType,
        nativeStatusSupported: nativeStatusSupported,
        horizontalRuleEnabled: horizontalRuleEnabled,
        expandEnabled: expandEnabled,
        insertMenuItems: insertMenuItems
      });
    }
  }] : [{
    type: TASK_LIST_GROUP.type,
    key: TASK_LIST_GROUP.key,
    parents: [{
      type: INSERT_BLOCK_SECTION.type,
      key: INSERT_BLOCK_SECTION.key,
      rank: INSERT_BLOCK_SECTION_RANK[TASK_LIST_GROUP.key]
    }],
    component: expValEquals('platform_editor_toolbar_aifc_responsive', 'isEnabled', true) ? function (_ref2) {
      var children = _ref2.children;
      return /*#__PURE__*/React.createElement(Show, {
        above: "lg"
      }, /*#__PURE__*/React.createElement(ToolbarButtonGroup, null, children));
    } : undefined
  }, {
    type: TASK_LIST_BUTTON.type,
    key: TASK_LIST_BUTTON.key,
    parents: [{
      type: TASK_LIST_GROUP.type,
      key: TASK_LIST_GROUP.key,
      rank: TASK_LIST_GROUP_RANK[TASK_LIST_BUTTON.key]
    }],
    component: function component() {
      return /*#__PURE__*/React.createElement(TaskListButton, {
        api: api
      });
    }
  }, {
    type: MEDIA_GROUP.type,
    key: MEDIA_GROUP.key,
    parents: [{
      type: INSERT_BLOCK_SECTION.type,
      key: INSERT_BLOCK_SECTION.key,
      rank: INSERT_BLOCK_SECTION_RANK[MEDIA_GROUP.key]
    }],
    component: expValEquals('platform_editor_toolbar_aifc_responsive', 'isEnabled', true) ? function (_ref3) {
      var children = _ref3.children;
      return /*#__PURE__*/React.createElement(Show, {
        above: "lg"
      }, /*#__PURE__*/React.createElement(ToolbarButtonGroup, null, children));
    } : undefined
  }, {
    type: MEDIA_BUTTON.type,
    key: MEDIA_BUTTON.key,
    parents: [{
      type: MEDIA_GROUP.type,
      key: MEDIA_GROUP.key,
      rank: MEDIA_GROUP_RANK[MEDIA_BUTTON.key]
    }],
    component: function component() {
      return !!(api !== null && api !== void 0 && api.imageUpload) ? /*#__PURE__*/React.createElement(ImageButton, {
        api: api
      }) : /*#__PURE__*/React.createElement(MediaButton, {
        api: api
      });
    }
  }, {
    type: MENTION_GROUP.type,
    key: MENTION_GROUP.key,
    parents: [{
      type: INSERT_BLOCK_SECTION.type,
      key: INSERT_BLOCK_SECTION.key,
      rank: INSERT_BLOCK_SECTION_RANK[MENTION_GROUP.key]
    }],
    component: expValEquals('platform_editor_toolbar_aifc_responsive', 'isEnabled', true) ? function (_ref4) {
      var children = _ref4.children;
      return /*#__PURE__*/React.createElement(Show, {
        above: "lg"
      }, /*#__PURE__*/React.createElement(ToolbarButtonGroup, null, children));
    } : undefined
  }, {
    type: MENTION_BUTTON.type,
    key: MENTION_BUTTON.key,
    parents: [{
      type: MENTION_GROUP.type,
      key: MENTION_GROUP.key,
      rank: MENTION_GROUP_RANK[MENTION_BUTTON.key]
    }],
    component: function component() {
      return /*#__PURE__*/React.createElement(MentionButton, {
        api: api
      });
    }
  }, {
    type: EMOJI_GROUP.type,
    key: EMOJI_GROUP.key,
    parents: [{
      type: INSERT_BLOCK_SECTION.type,
      key: INSERT_BLOCK_SECTION.key,
      rank: INSERT_BLOCK_SECTION_RANK[EMOJI_GROUP.key]
    }],
    component: expValEquals('platform_editor_toolbar_aifc_responsive', 'isEnabled', true) ? function (_ref5) {
      var children = _ref5.children;
      return /*#__PURE__*/React.createElement(Show, {
        above: "lg"
      }, /*#__PURE__*/React.createElement(ToolbarButtonGroup, null, children));
    } : undefined
  }, {
    type: EMOJI_BUTTON.type,
    key: EMOJI_BUTTON.key,
    parents: [{
      type: EMOJI_GROUP.type,
      key: EMOJI_GROUP.key,
      rank: EMOJI_GROUP_RANK[EMOJI_BUTTON.key]
    }],
    component: function component() {
      return /*#__PURE__*/React.createElement(EmojiButton, {
        api: api
      });
    }
  }, {
    type: LAYOUT_GROUP.type,
    key: LAYOUT_GROUP.key,
    parents: [{
      type: INSERT_BLOCK_SECTION.type,
      key: INSERT_BLOCK_SECTION.key,
      rank: INSERT_BLOCK_SECTION_RANK[LAYOUT_GROUP.key]
    }],
    component: expValEquals('platform_editor_toolbar_aifc_responsive', 'isEnabled', true) ? function (_ref6) {
      var children = _ref6.children;
      return /*#__PURE__*/React.createElement(Show, {
        above: "lg"
      }, /*#__PURE__*/React.createElement(ToolbarButtonGroup, null, children));
    } : undefined
  }, {
    type: LAYOUT_BUTTON.type,
    key: LAYOUT_BUTTON.key,
    parents: [{
      type: LAYOUT_GROUP.type,
      key: LAYOUT_GROUP.key,
      rank: LAYOUT_GROUP_RANK[LAYOUT_BUTTON.key]
    }],
    component: function component() {
      return /*#__PURE__*/React.createElement(LayoutButton, {
        api: api
      });
    }
  }, {
    type: TABLE_GROUP.type,
    key: TABLE_GROUP.key,
    parents: [{
      type: INSERT_BLOCK_SECTION.type,
      key: INSERT_BLOCK_SECTION.key,
      rank: INSERT_BLOCK_SECTION_RANK[TABLE_GROUP.key]
    }],
    component: expValEquals('platform_editor_toolbar_aifc_responsive', 'isEnabled', true) ? function (_ref7) {
      var children = _ref7.children;
      return /*#__PURE__*/React.createElement(Show, {
        above: "md"
      }, /*#__PURE__*/React.createElement(ToolbarButtonGroup, null, children));
    } : undefined
  }, {
    type: TABLE_BUTTON.type,
    key: TABLE_BUTTON.key,
    parents: [{
      type: TABLE_GROUP.type,
      key: TABLE_GROUP.key,
      rank: TABLE_GROUP_RANK[TABLE_BUTTON.key]
    }],
    component: function component() {
      return /*#__PURE__*/React.createElement(TableButton, {
        api: api
      });
    }
  }, {
    type: TABLE_SIZE_PICKER.type,
    key: TABLE_SIZE_PICKER.key,
    parents: [{
      type: TABLE_GROUP.type,
      key: TABLE_GROUP.key,
      rank: TABLE_GROUP_RANK[TABLE_SIZE_PICKER.key]
    }],
    component: function component() {
      return /*#__PURE__*/React.createElement(TableSizePicker, {
        api: api,
        tableSelectorSupported: tableSelectorSupported
      });
    }
  }, {
    type: INSERT_GROUP.type,
    key: INSERT_GROUP.key,
    parents: [{
      type: INSERT_BLOCK_SECTION.type,
      key: INSERT_BLOCK_SECTION.key,
      rank: INSERT_BLOCK_SECTION_RANK[INSERT_GROUP.key]
    }]
  }, {
    type: INSERT_BUTTON.type,
    key: INSERT_BUTTON.key,
    parents: [{
      type: INSERT_GROUP.type,
      key: INSERT_GROUP.key,
      rank: INSERT_GROUP_RANK[INSERT_BUTTON.key]
    }],
    component: function component() {
      return /*#__PURE__*/React.createElement(InsertButton, {
        api: api,
        showElementBrowserLink: showElementBrowserLink,
        tableSelectorSupported: tableSelectorSupported,
        onInsertBlockType: onInsertBlockType,
        nativeStatusSupported: nativeStatusSupported,
        horizontalRuleEnabled: horizontalRuleEnabled,
        expandEnabled: expandEnabled,
        insertMenuItems: insertMenuItems,
        numberOfButtons: 7 // TODO: ED-28759 - Default to 7 buttons - Remove this once we have a proper way to do toolbar responsiveness
      });
    }
  }]);
};